import { createFileRoute } from "@tanstack/react-router";
import { MarketingShell } from "@/components/site/marketing-shell";
import { Shield, Globe2, Headphones, TrendingUp } from "lucide-react";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — CryptoBull Pro" },
      { name: "description", content: "Learn about CryptoBull Pro, a demonstration cryptocurrency investment platform template." },
      { property: "og:title", content: "About CryptoBull Pro" },
      { property: "og:description", content: "Learn about CryptoBull Pro." },
    ],
  }),
  component: About,
});

function About() {
  return (
    <MarketingShell>
      <section className="mx-auto max-w-4xl px-4 py-20">
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">About CryptoBull Pro</h1>
        <p className="mt-6 text-lg text-muted-foreground">
          CryptoBull Pro is a premium dark-themed demonstration platform showcasing what a full-stack crypto investment app can look like — tiered plans, real-time dashboards, referral programs, and an admin control center.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mt-12">
          {[
            { i: Shield, t: "Security first", d: "Row-Level Security on every table, role-based admin access, encrypted wallet storage." },
            { i: TrendingUp, t: "Built for scale", d: "Optimized Postgres schema, indexed queries, and a clean server-function architecture." },
            { i: Globe2, t: "Worldwide", d: "Multi-currency display, time-zone aware, and translatable copy throughout." },
            { i: Headphones, t: "24/7 support", d: "Built-in ticket system with admin replies and announcements." },
          ].map(({ i: Ic, t, d }) => (
            <div key={t} className="glass rounded-2xl p-6">
              <Ic className="h-6 w-6 text-primary mb-3" />
              <div className="font-semibold">{t}</div>
              <p className="mt-1 text-sm text-muted-foreground">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 glass rounded-2xl p-8">
          <h2 className="text-2xl font-semibold">Our mission</h2>
          <p className="mt-3 text-muted-foreground">
            Demonstrate that fintech-grade UX is achievable without sacrificing transparency or security. Every part of this platform — from the live BTC ticker to the admin approval flows — is fully wired and reproducible.
          </p>
        </div>
      </section>
    </MarketingShell>
  );
}